var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useContext, useRef } from "react";
import { Link } from 'react-router-dom';
import { QRCode } from 'antd';
import UserPageLayout from '../../../../components/user/UserPageLayout';
import { AuthContext } from '../../../../components/FirebaseAuth';
import { FirebaseAuth } from '../../../../components/FirebaseAuth/firebase';
import { Form, Field, Input } from '../../../../components/Form';
import Alert from '../../../../components/Alert';
import Loader from '../../../../components/Loader';
import CopyableElement from '../../../../components/CopyableElement';
import { log, ENABLE_TWO_FACTOR, DISABLE_TWO_FACTOR } from '../../../../libs/log';
import { refreshTotpFactors, getTotpFactors, needsPassword, reauthenticate, resolveTotpChallenge, isMfaRequired, isRecentLoginRequired, isBadCode, mfaErrorMessage, startTotpEnrollment, finishTotpEnrollment, unenrollTotp } from '../../../../libs/mfa';
/**
 * Turn two-factor authentication on or off.
 *
 * One page handles both, because the profile row links to one place and what the
 * visitor can do depends on whether they are already enrolled.
 *
 * Reauthentication is a lazy retry, not a gate. getSession() makes no network call
 * and never demands a recent login; the server raises that on generateSecret,
 * enroll and unenroll. So each of those is attempted first and REAUTH is entered
 * only if it comes back, then the original action is retried.
 *
 * The CHALLENGE step matters more than it looks: unenroll on an already-enrolled
 * account can itself demand the second factor. Without it, turning 2FA off would be
 * impossible for exactly the people who need to.
 */
var CHECKING = 'checking';
var UNVERIFIED = 'unverified';
var INTRO = 'intro';
var REAUTH = 'reauth';
var CHALLENGE = 'challenge';
var SECRET = 'secret';
var ENROLLED = 'enrolled';
var CONFIRM_OFF = 'confirm-off';
var SUCCESS = 'success';
var FAILURE = 'failure';
var EMPTY = { hasError: false, error: null, value: '' };
var TwoFactor = function () {
    var _a;
    var title = 'Two-Factor Authentication';
    var authUser = useContext(AuthContext).authUser;
    var _b = useState(CHECKING), step = _b[0], setStep = _b[1];
    var _c = useState(false), inSubmit = _c[0], setInSubmit = _c[1];
    var _d = useState(''), message = _d[0], setMessage = _d[1];
    var _e = useState([]), factors = _e[0], setFactors = _e[1];
    var _f = useState(EMPTY), password = _f[0], setPassword = _f[1];
    var _g = useState(EMPTY), code = _g[0], setCode = _g[1];
    var _h = useState(null), secret = _h[0], setSecret = _h[1];
    var _j = useState(''), otpauthUrl = _j[0], setOtpauthUrl = _j[1];
    // Which action REAUTH/CHALLENGE should resume once the visitor has proved
    // themselves. Both steps are shared between enrol and unenrol.
    var pendingActionRef = useRef(null);
    var resolverRef = useRef(null);
    var secretRef = useRef(null);
    var user = authUser.user;
    useEffect(function () {
        var cancelled = false;
        var check = function () { return __awaiter(void 0, void 0, void 0, function () {
            var found, err_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!user) {
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, refreshTotpFactors()];
                    case 2:
                        found = _b.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setFactors(found);
                        if (!((_a = FirebaseAuth.auth().currentUser) === null || _a === void 0 ? void 0 : _a.emailVerified)) {
                            setStep(UNVERIFIED);
                        }
                        else {
                            setStep(found.length > 0 ? ENROLLED : INTRO);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _b.sent();
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        setMessage(mfaErrorMessage(err_1));
                        setStep(FAILURE);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        check();
        return function () { cancelled = true; };
    }, [user]);
    var fail = function (err) {
        setMessage(mfaErrorMessage(err));
        setStep(FAILURE);
        setInSubmit(false);
    };
    /**
     * Runs enrol or unenrol, diverting to REAUTH or CHALLENGE when the server asks
     * for more proof and remembering what to resume.
     */
    var runAction = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var current, generated, target, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    current = FirebaseAuth.auth().currentUser;
                    if (!current) {
                        setStep(FAILURE);
                        setMessage('You are no longer signed in.');
                        return [2 /*return*/];
                    }
                    setInSubmit(true);
                    setMessage('');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!(action === 'enroll')) return [3 /*break*/, 3];
                    return [4 /*yield*/, startTotpEnrollment(current)];
                case 2:
                    generated = _a.sent();
                    secretRef.current = generated;
                    setSecret(generated);
                    // Both arguments are required: the default issuer is the Firebase app
                    // name, which for the default app is the literal string "[DEFAULT]"
                    // and would show up as that in the visitor's authenticator.
                    setOtpauthUrl(generated.generateQrCodeUrl(current.email || current.uid, 'LTIAAS'));
                    setCode(EMPTY);
                    setStep(SECRET);
                    return [3 /*break*/, 5];
                case 3:
                    target = getTotpFactors()[0] || factors[0];
                    if (!target) {
                        setStep(INTRO);
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, unenrollTotp(current, target)];
                case 4:
                    _a.sent();
                    log(DISABLE_TWO_FACTOR);
                    setMessage('Two-factor authentication has been turned off.');
                    setStep(SUCCESS);
                    _a.label = 5;
                case 5:
                    setInSubmit(false);
                    return [3 /*break*/, 7];
                case 6:
                    err_2 = _a.sent();
                    pendingActionRef.current = action;
                    if (isRecentLoginRequired(err_2)) {
                        setPassword(EMPTY);
                        setStep(REAUTH);
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    if (isMfaRequired(err_2)) {
                        resolverRef.current = err_2.resolver;
                        setCode(EMPTY);
                        setStep(CHALLENGE);
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    fail(err_2);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var submitReauth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var current, action, err_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    current = FirebaseAuth.auth().currentUser;
                    if (!current) {
                        setStep(FAILURE);
                        setMessage('You are no longer signed in.');
                        return [2 /*return*/];
                    }
                    setInSubmit(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, reauthenticate(current, password.value)];
                case 2:
                    _a.sent();
                    action = pendingActionRef.current;
                    pendingActionRef.current = null;
                    if (!action) return [3 /*break*/, 4];
                    return [4 /*yield*/, runAction(action)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setStep(INTRO);
                    setInSubmit(false);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_3 = _a.sent();
                    if (isMfaRequired(err_3)) {
                        resolverRef.current = err_3.resolver;
                        setCode(EMPTY);
                        setStep(CHALLENGE);
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    if ((err_3 === null || err_3 === void 0 ? void 0 : err_3.code) === 'auth/wrong-password' || (err_3 === null || err_3 === void 0 ? void 0 : err_3.code) === 'auth/invalid-credential') {
                        setPassword({ hasError: true, error: 'Incorrect password, authentication failed.', value: password.value });
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    fail(err_3);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var submitChallenge = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resolver, action, err_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    resolver = resolverRef.current;
                    if (!resolver) {
                        setStep(FAILURE);
                        setMessage('That request expired. Please try again.');
                        return [2 /*return*/];
                    }
                    setInSubmit(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, resolveTotpChallenge(resolver, code.value)];
                case 2:
                    _a.sent();
                    resolverRef.current = null;
                    action = pendingActionRef.current;
                    pendingActionRef.current = null;
                    if (!action) return [3 /*break*/, 4];
                    return [4 /*yield*/, runAction(action)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setStep(INTRO);
                    setInSubmit(false);
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    err_4 = _a.sent();
                    if (isBadCode(err_4)) {
                        setCode({ hasError: true, error: mfaErrorMessage(err_4), value: code.value });
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    fail(err_4);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var submitEnrollCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var current, activeSecret, err_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    current = FirebaseAuth.auth().currentUser;
                    activeSecret = secretRef.current || secret;
                    if (!current || !activeSecret) {
                        setStep(FAILURE);
                        setMessage('That setup expired. Please start again.');
                        return [2 /*return*/];
                    }
                    setInSubmit(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, finishTotpEnrollment(current, activeSecret, code.value)];
                case 2:
                    _a.sent();
                    log(ENABLE_TWO_FACTOR);
                    setMessage('Two-factor authentication is on. You will be asked for a code the next time you sign in.');
                    setStep(SUCCESS);
                    setInSubmit(false);
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _a.sent();
                    // Keep the secret and stay put — they mistyped, or their device clock
                    // has drifted. Restarting would make them scan a new code for nothing.
                    if (isBadCode(err_5)) {
                        setCode({ hasError: true, error: mfaErrorMessage(err_5), value: code.value });
                        setInSubmit(false);
                        return [2 /*return*/];
                    }
                    fail(err_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var restart = function () {
        pendingActionRef.current = null;
        resolverRef.current = null;
        secretRef.current = null;
        setSecret(null);
        setOtpauthUrl('');
        setPassword(EMPTY);
        setCode(EMPTY);
        setMessage('');
        setStep(CHECKING);
        refreshTotpFactors()
            .then(function (found) {
            var _a;
            setFactors(found);
            if (!((_a = FirebaseAuth.auth().currentUser) === null || _a === void 0 ? void 0 : _a.emailVerified)) {
                setStep(UNVERIFIED);
            }
            else {
                setStep(found.length > 0 ? ENROLLED : INTRO);
            }
        })
            .catch(function (err) { setMessage(mfaErrorMessage(err)); setStep(FAILURE); });
    };
    var codeField = function (label, onSubmit, submitText) { return (_jsx(Form, { handleSubmit: function (e) { e.preventDefault(); onSubmit(); }, disabled: code.hasError || code.value.length !== 6 || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, submitBtnText: submitText, backToUrl: "/user/profile", children: _jsx(Field, { label: label, children: _jsx(Input, { type: "text", name: "totp-code", inputMode: "numeric", autoComplete: "one-time-code", minLen: 6, maxLen: 6, validRegex: "^[0-9]{6}$", customErrorMessage: "Enter the 6-digit code from your authenticator app.", required: true, hasError: code.hasError, error: code.error, changeHandler: setCode }) }) })); };
    return (_jsxs(UserPageLayout, { title: title, children: [step === CHECKING && _jsx(Loader, { text: "Checking your settings..." }), step === UNVERIFIED &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "warning", dismissible: false, message: "You need to verify your email address before you can turn on two-factor authentication.", onDismiss: function () { } }), _jsx(Link, { className: "btn btn-primary mr-2", to: "/user/profile/verify-email", children: "Verify Your Email" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "Back to Profile" })] }), step === INTRO &&
                _jsxs(_Fragment, { children: [_jsx("p", { children: "Two-factor authentication adds a second step when you sign in. As well as your password, you enter a 6-digit code from an authenticator app on your phone \u2014 so your account stays safe even if someone learns your password." }), _jsx("p", { children: "You'll need an authenticator app such as Google Authenticator, 1Password, Microsoft Authenticator or Authy." }), _jsx(Alert, { type: "info", dismissible: false, message: "Keep your authenticator app safe. If you lose access to it, you'll need to contact support@ltiaas.com to get back into your account.", onDismiss: function () { } }), _jsxs("button", { type: "button", className: "btn btn-primary mr-2", disabled: inSubmit, onClick: function () { return runAction('enroll'); }, children: [inSubmit && _jsx("i", { className: "fa fa-spinner fa-spin mr-2" }), "Set Up Two-Factor Authentication"] }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "Back to Profile" })] }), step === REAUTH &&
                _jsxs(_Fragment, { children: [_jsx("p", { children: "For your security, please confirm it's you before we change this setting." }), needsPassword(FirebaseAuth.auth().currentUser) ? (_jsx(Form, { handleSubmit: function (e) { e.preventDefault(); submitReauth(); }, disabled: password.hasError || password.value === '' || inSubmit, inSubmit: inSubmit, enableDefaultButtons: true, submitBtnText: "Continue", backToUrl: "/user/profile", children: _jsx(Field, { label: "Current Password", children: _jsx(Input, { type: "password", name: "current-password", autoComplete: "current-password", required: true, hasError: password.hasError, error: password.error, changeHandler: setPassword }) }) })) : (_jsxs(_Fragment, { children: [_jsxs("button", { type: "button", className: "btn btn-primary mr-2", disabled: inSubmit, onClick: submitReauth, children: [inSubmit && _jsx("i", { className: "fa fa-spinner fa-spin mr-2" }), "Confirm With Your Sign-In Provider"] }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "Cancel" })] }))] }), step === CHALLENGE &&
                _jsxs(_Fragment, { children: [_jsx("p", { children: "Enter the current code from your authenticator app to confirm this change." }), codeField('Verification Code', submitChallenge, 'Confirm')] }), step === SECRET &&
                _jsxs(_Fragment, { children: [_jsx("p", { children: "Scan this code with your authenticator app, then enter the 6-digit code it shows to finish. Complete this within a few minutes or you'll need to start again." }), otpauthUrl !== '' &&
                            _jsx(Field, { label: "1. Scan", children: _jsx(QRCode, { value: otpauthUrl, size: 200, errorLevel: "M", bordered: true }) }), (secret === null || secret === void 0 ? void 0 : secret.secretKey) &&
                            _jsx(Field, { label: "", description: "Can't scan it? Type this key into your app instead.", children: _jsx(CopyableElement, { value: secret.secretKey }) }), codeField('2. Enter the code from your app', submitEnrollCode, 'Turn On Two-Factor Authentication')] }), step === ENROLLED &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "success", dismissible: false, message: "Two-factor authentication is on for your account.", onDismiss: function () { } }), _jsxs("p", { children: ["You'll be asked for a code from your authenticator app each time you sign in.", ((_a = factors[0]) === null || _a === void 0 ? void 0 : _a.enrollmentTime) &&
                                    _jsxs(_Fragment, { children: [" Added ", new Date(factors[0].enrollmentTime).toLocaleDateString(), "."] })] }), _jsx("button", { type: "button", className: "btn btn-danger mr-2", onClick: function () { return setStep(CONFIRM_OFF); }, children: "Turn Off Two-Factor Authentication" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "Back to Profile" })] }), step === CONFIRM_OFF &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "warning", dismissible: false, message: "Turning this off means your password alone will be enough to sign in to your account.", onDismiss: function () { } }), _jsxs("button", { type: "button", className: "btn btn-danger mr-2", disabled: inSubmit, onClick: function () { return runAction('unenroll'); }, children: [inSubmit && _jsx("i", { className: "fa fa-spinner fa-spin mr-2" }), "Turn It Off"] }), _jsx("button", { type: "button", className: "btn btn-secondary", disabled: inSubmit, onClick: function () { return setStep(ENROLLED); }, children: "Keep It On" })] }), step === SUCCESS &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "success", dismissible: false, message: message, onDismiss: function () { } }), _jsx(Link, { className: "btn btn-primary", to: "/user/profile", children: "View Profile" })] }), step === FAILURE &&
                _jsxs(_Fragment, { children: [_jsx(Alert, { type: "danger", dismissible: false, message: message, onDismiss: function () { } }), _jsx("button", { type: "button", className: "btn btn-primary mr-2", onClick: restart, children: "Try Again" }), _jsx(Link, { className: "btn btn-secondary", to: "/user/profile", children: "View Profile" })] })] }));
};
export default TwoFactor;
